/**
 * @description 为服务中心详情正文生成稳定的标题锚点和目录数据。
 */

const generateAnchorId = (text, index) => {
  if (!text) return `heading-${index}`

  let id = text
    .trim()
    .toLowerCase()
    .replace(/[^\u4e00-\u9fa5a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

  if (!id || /^\d/.test(id)) id = `heading-${index}`
  return id || `heading-${index}`
}

export const processServiceDetailHtmlWithToc = (html) => {
  const raw = String(html || '')
  if (!raw) return { html: '', tocItems: [] }
  if (typeof DOMParser === 'undefined') return { html: raw, tocItems: [] }

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(raw, 'text/html')
    const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6')
    const tocItems = []
    const usedIds = new Set()

    headings.forEach((heading, index) => {
      const level = Number.parseInt(heading.tagName.slice(1), 10)
      const text = heading.textContent?.trim() || ''
      let id = heading.id

      if (!id || usedIds.has(id)) {
        const baseId = generateAnchorId(text, index)
        id = baseId
        let counter = 1
        while (usedIds.has(id)) {
          id = `${baseId}-${counter}`
          counter += 1
        }
      }

      usedIds.add(id)
      heading.id = id
      tocItems.push({ id, text, level })
    })

    return { html: doc.body?.innerHTML || '', tocItems }
  } catch (error) {
    console.error('处理HTML失败:', error)
    return { html: raw, tocItems: [] }
  }
}
